module.exports = __webpack_public_path__ + "img/ts12.7e3c0b88.png";